import React from 'react';
import { JSX } from 'react/jsx-runtime';


function FooterComponent() {
    return (

        <footer className="bg-gray-100 inset-x-0 bottom-0">
            <div className="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8 ">
                <div className="flex justify-center gap-x-6 md:order-2">
                </div>
                <p className="mt-8 text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">
                    &copy; Grupo Brame 2025
                </p>
            </div>
        </footer>

    );
}

export default FooterComponent;